import React from 'react';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import SimActivationPageData from 'Models/Content/SimActivationPageData';
import {SimActivationProvider} from './SimActivationContext';
export default class SimActivationPage extends Page<SimActivationPageData> {
  render() {
    const {
      data: {mainContentArea},
      context,
    } = this.props;

    return (
      <div className='SimActivationPage'>
        <SimActivationProvider>
          <ContentArea data={mainContentArea} context={context} />
        </SimActivationProvider>
      </div>
    );
  }
}
